{ "version": "0.6.0", "protocol": 4 }
